// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","buttonRed":"Button_buttonRed__06fTD Button_button__wiIYs"};